import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  margin: 24px 0px;\n'], ['\n  margin: 24px 0px;\n']);

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import WhenField from '../../../fields/When';
import EstimatedTimeField from '../../../fields/EstimatedTime';
import ReviewInputLinkField from '../../../fields/ReviewInputLink';
import Tags from '../../../fields/Tags';
import get from 'lodash/get';

var ReviewFields = function (_PureComponent) {
  _inherits(ReviewFields, _PureComponent);

  function ReviewFields() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReviewFields);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReviewFields.__proto__ || Object.getPrototypeOf(ReviewFields)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: null
    }, _this.toggleField = function (e, id) {
      _this.setState({
        open: _this.state.open !== id ? id : null
      });
    }, _this.onChange = function (_ref2) {
      var paramName = _ref2.paramName,
          value = _ref2.value,
          method = _ref2.method;

      _this.props.onChange({ paramName: paramName, value: value, method: method });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReviewFields, [{
    key: 'render',
    value: function render() {
      var open = this.state.open;
      var review = this.props.review;


      var estimatedTimeValue = review ? review.estimatedTime : '';

      return React.createElement(
        Container,
        null,
        React.createElement(ReviewInputLinkField, {
          noPadding: true,
          backgroundHover: 'transparent',
          editable: false,
          mode: 'edit',
          id: 'reviewInputLink',
          value: review && review.reviewInputLink,
          onChange: this.onChange
        }),
        React.createElement(WhenField, {
          noPadding: true,
          backgroundHover: 'transparent',
          showClose: false,
          id: 'when.date',
          label: 'Plan review',
          mode: 'edit',
          isActive: true,
          isOpen: open === 'when.date',
          onChange: this.onChange,
          toggleField: this.toggleField,
          value: get(review, 'when.date'),
          shouldHideRecurring: true,
          pinTime: get(review, 'pin.time'),
          pinDate: get(review, 'pin.date'),
          shouldBlockInCalendar: get(review, 'shouldBlockInCalendar')
        }),
        React.createElement(EstimatedTimeField, {
          noPadding: true,
          backgroundHover: 'transparent',
          showClose: false,
          id: 'estimatedTime',
          label: 'Review estimate',
          mode: 'edit',
          value: estimatedTimeValue,
          isActive: true,
          isOpen: open === 'estimatedTime',
          onChange: this.onChange,
          toggleField: this.toggleField
        }),
        React.createElement(Tags, {
          noPadding: true,
          backgroundHover: 'transparent',
          label: 'Tags',
          isActive: true,
          id: 'tags',
          value: get(review, 'tags'),
          onChange: this.onChange
        })
      );
    }
  }]);

  return ReviewFields;
}(PureComponent);

ReviewFields.propTypes = {
  review: PropTypes.object,
  onChange: PropTypes.func.isRequired
};


export default ReviewFields;

var Container = styled.div(_templateObject);
//# sourceMappingURL=ReviewFields.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/components/Header/Review/ReviewFields.js
// module id = 486
// module chunks = 0